import React from 'react';
export var Page = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: className }, children));
};
//# sourceMappingURL=Page.js.map